import React, { useState, useContext } from "react"
import { Mutation } from "react-apollo"
import Button from "../../../../../components/Button"
import gql from "graphql-tag"
import { ModalMessage } from "../../../../../components/Modal"
import { getRecentFavorites } from "../../../queries"
import AppContext from "../../../../../shared/AppContext"

const DELETE_FAVORITE_FOLDER = gql`
  mutation DELETE_FAVORITE_FOLDER($folderId: String!) {
    deleteFavoritesFolder(folderId: $folderId) {
      response {
        payload
        message
      }
    }
  }
`

const MESSAGE_TYPE = {
  SUCCESS: "success",
  SAVE_ERROR: "saveError",
  NOT_AUTHORIZED: "notAuthorized",
}
export default function FolderDelete(props) {
  const [message, setMessage] = useState({
    type: "",
    text: "",
  })

  const { folderName, closeModal, trackingLocation } = props
  const { trackEvent } = useContext(AppContext)

  const handleDelete = (mutation) => {
    mutation({
      variables: {
        folderId: props.folderId,
      },
      refetchQueries: [{ query: getRecentFavorites }],
    })
      .then(({ data }) => {
        const { deleteFavoritesFolder } = data
        setMessage({
          type: deleteFavoritesFolder.response.payload,
          text: deleteFavoritesFolder.response.message,
        })
        if (
          deleteFavoritesFolder.response &&
          deleteFavoritesFolder.response.payload === MESSAGE_TYPE.SUCCESS
        ) {
          trackEvent("Deleted Folder", {
            location: trackingLocation,
            folderName: folderName,
          })
        }
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text:
            "Oh no! Something went wrong. Please go to https://app.etr.ai/help to get support",
        })
        console.log("folder delete error", err)
      })
  }

  if (message.type.toLowerCase() == MESSAGE_TYPE.SUCCESS.toLowerCase()) {
    return (
      <ModalMessage
        messageType={MESSAGE_TYPE.SUCCESS}
        text={message.text}
        closeModal={closeModal}
      />
    )
  }

  const hasErrors =
    message.type.toLowerCase() == MESSAGE_TYPE.SAVE_ERROR.toLowerCase() ||
    message.type.toLowerCase() == MESSAGE_TYPE.NOT_AUTHORIZED.toLowerCase()

  return (
    <Mutation mutation={DELETE_FAVORITE_FOLDER}>
      {(mutation) => {
        return (
          <div>
            <p>Please confirm that you want to delete this folder.</p>
            <i className="folder-edit-warning warning">
              NOTE: Deleting this folder will also delete all the favorites in
              this folder.
            </i>
            <p
              style={{
                padding: ".8rem",
                fontSize: "2rem",
                fontStyle: "italic",
                fontWeight: "100",
              }}
            >
              {folderName}
            </p>
            {hasErrors && (
              <ModalMessage
                messageType={MESSAGE_TYPE.SAVE_ERROR}
                text={message.text}
                style={{ textAlign: "right" }}
              />
            )}
            <div className="folder-edit-button-wrap">
              <Button
                action={closeModal}
                text="Cancel"
                classes={["btn-cancel"]}
              />
              <Button
                action={() => handleDelete(mutation)}
                text="Confirm Delete"
                classes={["btn-primary"]}
              />
            </div>
          </div>
        )
      }}
    </Mutation>
  )
}
